import { OPERACIONES_PEOPLE } from "./whatsappPermissions";

type LinkedThread = {
  source?: string;
  caseId?: string;
};

type OperationsThread = {
  assignedOperaciones?: string | null;
};

// Los chats de Form Simple y Meta guardan el id original del caso, mientras
// que ANDI usa un prefijo para que ambos orígenes puedan compartir crmLeads.
export const crmLeadIdForWhatsappThread = (thread: LinkedThread): string => {
  const caseId = String(thread.caseId || "").trim();
  if (!caseId) return "";
  if (thread.source === "form-simple") return `form-${caseId}`;
  if (thread.source === "meta-ads") return `meta-${caseId}`;
  return "";
};

// Derivar sigue siendo una acción manual. En ese momento copiamos el analista
// que ya tiene el lead en ANDI, pero nunca pisamos al owner elegido a mano ni
// inventamos una asignación para un origen sin vínculo inequívoco.
export const operationsHandoffPatch = (
  thread: OperationsThread,
  linkedAnalyst?: string | null,
): { area: "operaciones"; assignedOperaciones?: string } => {
  const current = String(thread.assignedOperaciones || "").trim();
  if (current) return { area: "operaciones" };

  const analyst = String(linkedAnalyst || "").trim();
  return OPERACIONES_PEOPLE.includes(analyst)
    ? { area: "operaciones", assignedOperaciones: analyst }
    : { area: "operaciones" };
};
